"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var qs = require("qs");
var UrlParse = require("url-parse");
var hash_util_1 = require("./hash_util");
var QueryParamsUtil = {
    queryParamsForUrl: function (hash) {
        var updatedHash = hash_util_1.default.rejectBlankValues(hash);
        return "?" + qs.stringify(updatedHash);
    },
    getParamValue: function (key, url) {
        var href = url || window.location.href;
        var queryString = new UrlParse(href).query.replace(/^\?/, '');
        return qs.parse(queryString)[key] || null;
    },
};
exports.default = QueryParamsUtil;
//# sourceMappingURL=query_params_util.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/reverb-js-common/query_params_util.js
// module id = gw1J
// module chunks = 20 21 22